var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.836 1.248c.159.001.315.038.46.107v-.001l.005.003h.004l-.001.002L14.296 7.02l.134.075a1.082 1.082 0 0 1-.134 1.884L2.302 14.642c0 .002-.003.001-.004.002l-.002.002v-.001A1.08 1.08 0 0 1 .82 13.288H.819l1.894-5.085.027-.1a.583.583 0 0 0 0-.206l-.027-.1L.818 2.711c-.075-.201-.09-.42-.041-.628l.048-.155a1.082 1.082 0 0 1 .85-.669l.161-.012zM4.186 8.5c-.018.077-.04.152-.068.227l-1.537 4.125L11.796 8.5h-7.61zm-.068-1.227l.058.177.012.05H11.8L2.58 3.147l1.538 4.126z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export default ForwardRef;